"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GridlinesRenderable = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

/**
 *
 * @typedef Line
 * @type ReactElement
 *
 * @prop {Object} coordinates - The coordinates needed to draw the line
 * @prop {number} coordinates.x1 - The starting x position of the line
 * @prop {number} coordinates.y1 - The starting y position of the line
 * @prop {number} coordinates.x2 - The ending x position of the line
 * @prop {number} coordinates.y2 - The ending y position of the line
 *
 * @prop {*} tick - The tick value for this gridline
 * @prop {Scale} xScale - The x scale for the passed to the Gridlines component
 * @prop {Scale} yScale - The y scale for the passed to the Gridlines component
 */
var defaultLine = function defaultLine(props) {
  var coordinates = props.coordinates;
  return _react.default.createElement("line", (0, _extends2.default)({}, coordinates, {
    strokeWidth: "1",
    stroke: "inherit"
  }));
};

defaultLine.propTypes = {
  key: _propTypes.default.string.isRequired,
  coordinates: _propTypes.default.shape({
    x1: _propTypes.default.number.isRequired,
    y1: _propTypes.default.number.isRequired,
    x2: _propTypes.default.number.isRequired,
    y2: _propTypes.default.number.isRequired
  }).isRequired,
  tick: function tick(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `".concat(propName, "` has type 'any' or 'mixed', but was not provided to `").concat(componentName, "`. Pass undefined or any other value."));
    }
  },
  xScale: _propTypes.default.func.isRequired,
  yScale: _propTypes.default.func.isRequired
};

var GridlinesRenderable =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(GridlinesRenderable, _React$PureComponent);

  function GridlinesRenderable() {
    (0, _classCallCheck2.default)(this, GridlinesRenderable);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(GridlinesRenderable).apply(this, arguments));
  }

  (0, _createClass2.default)(GridlinesRenderable, [{
    key: "buildHorizontalGridlines",
    value: function buildHorizontalGridlines() {
      var _this = this;

      var LineHorizontal = this.props.lineHorizontal;
      var rangeX = this.props.xScale.range();
      var rangeY = this.props.yScale.range();
      var offset = this.props.yScale.bandwidth ? this.props.yScale.bandwidth() / 2 : 0;

      var _rangeX = (0, _slicedToArray2.default)(rangeX, 2),
          x1 = _rangeX[0],
          x2 = _rangeX[1];

      return this.props.yTicks(this.props.yScale).map(function (tick) {
        var y1 = rangeY[1] - (_this.props.yScale(tick) + offset);
        var y2 = y1;
        return _react.default.createElement(LineHorizontal, {
          key: tick,
          coordinates: {
            x1: x1,
            x2: x2,
            y1: y1,
            y2: y2
          },
          tick: tick,
          xScale: _this.props.xScale,
          yScale: _this.props.yScale
        });
      });
    }
  }, {
    key: "buildVerticalGridlines",
    value: function buildVerticalGridlines() {
      var _this2 = this;

      var LineVertical = this.props.lineVertical;
      var rangeY = this.props.yScale.range();
      var offset = this.props.xScale.bandwidth ? this.props.xScale.bandwidth() / 2 : 0;

      var _rangeY = (0, _slicedToArray2.default)(rangeY, 2),
          y1 = _rangeY[0],
          y2 = _rangeY[1];

      return this.props.xTicks(this.props.xScale).map(function (tick) {
        var x1 = _this2.props.xScale(tick) + offset;
        var x2 = x1;
        return _react.default.createElement(LineVertical, {
          key: tick,
          coordinates: {
            x1: x1,
            x2: x2,
            y1: y1,
            y2: y2
          },
          tick: tick,
          xScale: _this2.props.xScale,
          yScale: _this2.props.yScale
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("g", null, _react.default.createElement("g", null, this.buildHorizontalGridlines()), _react.default.createElement("g", null, this.buildVerticalGridlines()));
    }
  }]);
  return GridlinesRenderable;
}(_react.default.PureComponent);

exports.GridlinesRenderable = GridlinesRenderable;
(0, _defineProperty2.default)(GridlinesRenderable, "defaultProps", {
  lineHorizontal: defaultLine,
  lineVertical: defaultLine,
  xTicks: function xTicks(scale) {
    return scale.ticks ? scale.ticks() : scale.domain();
  },
  yTicks: function yTicks(scale) {
    return scale.ticks ? scale.ticks() : scale.domain();
  }
});
(0, _defineProperty2.default)(GridlinesRenderable, "propTypes", {
  lineVertical: _propTypes.default.func,
  lineHorizontal: _propTypes.default.func,
  xScale: _propTypes.default.func.isRequired,
  yScale: _propTypes.default.func.isRequired,
  xTicks: _propTypes.default.func,
  yTicks: _propTypes.default.func
});

var Gridlines =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Gridlines, _React$Component);

  function Gridlines() {
    (0, _classCallCheck2.default)(this, Gridlines);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Gridlines).apply(this, arguments));
  }

  (0, _createClass2.default)(Gridlines, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(GridlinesRenderable, this.props);
    }
  }]);
  return Gridlines;
}(_react.default.Component);

exports.default = Gridlines;
(0, _defineProperty2.default)(Gridlines, "chartType", 'canvas');